export default {
    data: () => ({
        translations: {
            image: {
                el: "Εικόνα",
                en: "Image",
                it: "Immagine"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Name"
            },
            type: {
                el: "Τύπος",
                en: "Type",
                it: "Τύπος"
            },
            points: {
                el: "Πόντοι (αξία)",
                en: "Points (value)",
                it: "Punti (valore)"
            },
            search: {
                el: "Αναζήτηση ",
                en: "Search",
                it: "Cerca"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
